import React from 'react';

interface UnitData {
  input?: string;
  output?: string;
  result?: string;
  error?: string;
}

interface Props {
  data: UnitData;
  isDarkMode?: boolean;
}

export const UnitConverterCard: React.FC<Props> = ({ data, isDarkMode = false }) => {
  const border = isDarkMode ? 'border-slate-700' : 'border-slate-200';
  const bg = isDarkMode ? 'bg-slate-900/40 text-white' : 'bg-white/70';
  const textMuted = isDarkMode ? 'text-white/70' : 'text-black/70';

  if (data.error) {
    return (
      <div className={`rounded-lg p-2 my-2 border ${border} ${bg}`}>❌ {data.error}</div>
    );
  }

  const value = data.output ?? data.result ?? '';

  return (
    <div className={`rounded-lg bg-transparent`}>
      {data.input && <div className={`text-xs mt-1 ${textMuted}`}>"{data.input}"</div>}
      <div className="text-base font-semibold">{value}</div>

    </div>
  );
};

export default UnitConverterCard;
